"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.identify = identify;
exports.activate = activate;
/**
 * Zendesk widget
 *
 * Include this file in a bundle to enable the Zendesk widget  I prefer having
 * this on the client so that it can be easily configured.  The widget API is a
 * little strange to work with so I've exposed this file to use as an interface.
 */

/* eslint-disable */
function init() {
    /*<![CDATA[*/
    window.zEmbed || function (e, t) {
        var n,
            o,
            d,
            i,
            s,
            a = [],
            r = document.createElement("iframe");
        window.zEmbed = function () {
            a.push(arguments);
        }, window.zE = window.zE || window.zEmbed, r.src = "javascript:false", r.title = "", r.role = "presentation", (r.frameElement || r).style.cssText = "display: none", d = document.getElementsByTagName("script"), d = d[d.length - 1], d.parentNode.insertBefore(r, d), i = r.contentWindow, s = i.document;
        try {
            o = s;
        } catch (c) {
            n = document.domain, r.src = "javascript:var d=document.open();d.domain=\"" + n + "\";void(0);", o = s;
        }
        o.open()._l = function () {
            var o = this.createElement("script");
            n && (this.domain = n), o.id = "js-iframe-async", o.src = e, this.t = +new Date(), this.zendeskHost = t, this.zEQueue = a, this.body.appendChild(o);
        }, o.write("<body onload=\"document._l();\">"), o.close();
    }("https://assets.zendesk.com/embeddable_framework/main.js", "hellosign.zendesk.com"); /*]]>*/
    /* eslint-enable */

    // Hide zendesk by default
    zE(function () {
        zE.hide();
    });
}

function identify(info) {
    zE(function () {
        zE.identify(info);
        zE.activateIpm();
    });
}

function activate() {
    zE(function () {
        zE.activate({
            hideOnClose: true
        });
    });
}

if (process.env.NODE_ENV !== 'test') {
    init();
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/common/zendesk/widget.js
 ** module id = 838
 ** module chunks = 0 1
 **/